import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import styles from './AuthField.module.css';

// The forwarded ref lands on the input wrapper, so an Autocomplete can anchor its popup to it.
const AuthField = forwardRef(({ id, label, error, prefix, type = 'text', inputProps, ...rest }, ref) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const isPassword = type === 'password';
  const errorId = `${id}-error`;

  const controlClasses = [
    styles.control,
    error && styles.invalid,
    prefix && styles.withPrefix,
    isPassword && styles.withToggle
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <div className={controlClasses} ref={ref}>
        {prefix && <span className={styles.prefix}>{prefix}</span>}
        <input
          id={id}
          type={isPassword && visible ? 'text' : type}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
          {...rest}
          {...inputProps}
          className={`${styles.input} ${inputProps?.className || ''}`}
        />
        {isPassword && (
          <button
            type='button'
            className={styles.toggle}
            onClick={() => setVisible(!visible)}
            aria-label={t('register.showPassword')}
            aria-pressed={visible}>
            {visible ? <VisibilityOff /> : <Visibility />}
          </button>
        )}
      </div>
      {error && (
        <p id={errorId} className={styles.error}>
          {error}
        </p>
      )}
    </div>
  );
});

export default AuthField;
